<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {

  },
  computed: {
  },
  data() {
    return {
      vm: {
        supplierName: null,
        address: null,
        phoneNo: null,
      },
    };
  },
  methods: {
    
    onFileUpload(file) {
      // Handle the file upload logic here
      console.log("File uploaded:", file);
    },
    confirm() {
      this.$store
        .dispatch("suppliers/add",  this.vm )
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>